module.exports = __webpack_public_path__ + "media/application/images/ui/icon-pinterest-f9eb963fbe3d299ab19e217169d7daab.png";